<script lang="ts">
  import LocomotiveScroll from "locomotive-scroll";
  import {onMount} from "svelte";
  import ParagraphContainer from "../ParagraphContainer/ParagraphContainer.svelte";
  import {store} from "../../store/store";
  import {onEnter} from "../../utils/onEnter";
  import Link from "../Link/Link.svelte";
  import Button from "../Button/Button.svelte";

  let progress: number;
  let svgElement: SVGSVGElement;
  let pathElement: SVGPathElement;
  let textPathElement: SVGTextPathElement;

  let layoutContainer: HTMLElement;
  let isMobile: boolean;
  let onMouseOver: () => void;
  let onMouseLeave: () => void;

  const updateTextPathOffset = (offset: number) => {
    textPathElement.setAttribute("startOffset", offset.toString());
  };

  // const onScroll = () => {
  //   requestAnimationFrame(() => {
  //     const rect = svgElement.getBoundingClientRect();
  //     const pathLength = pathElement.getTotalLength();
  //     const scrollPercentage = rect.y / window.innerHeight;
  //
  //     updateTextPathOffset(scrollPercentage * 0.09 * pathLength);
  //   });
  // };

  store.progressRatio.subscribe((value) => {
    progress = value;
  });

  store.isMobileDevice.subscribe((value) => {
    isMobile = value;
  });

  store.layoutContainer.subscribe((value) => {
    layoutContainer = value;
  });

  store.progressRatio.subscribe((value) => {
    progress = value;
  });

  onMount(() => {
    if (layoutContainer) {
      store.layoutContainer.update(() => layoutContainer);

      if (!isMobile) {
        layoutContainer.style.position = "fixed";
        const scroll = new LocomotiveScroll({
          el: document.querySelector("[data-scroll-container]"),
          smooth: true,
          lerp: 0.135,
          getSpeed: true,
        });

        scroll.on("scroll", (ev) => {
          const speed = ev.speed < 0.1 && ev.speed > -0.1 ? 0.0 : ev.speed;
          // onScroll();
          store.scrollSpeed.update(() => speed);
        });
      }
    }
  });
</script>

<section
	class="container"
	bind:this={layoutContainer}
	data-scroll-container={true}
>
	<div class="wrapper">
		<ParagraphContainer class="first" hasBackground={true}>
			<div class="w-full">
				<!-- <img class="logo" src="static/logo.png" alt="logo" /> -->
				<p class="text header-text">
					SOCCERPHORIA ART GALLERY
					<span></span>
					<span></span>
				</p>
				<p class="text">
					An immersive virtual gallery showcasing the greatness of artistic vision and the glory of soccer.
				</p>
				<p class="text">
					The advancements in virtual reality technology brings forth a new expansive world for art to flourish. The return of soccer’s greatest event in the 2022 World Cup brings an air of hope and joy for all spectators around the world. The two together form the promise of a brighter future.
				</p>
				<p class="text">
					And we believe that a bright future is a cause for celebration. Collaborating with 10 talented artists, Soccerphoria Art Gallery brings 20 masterfully crafted visual artworks to life in a unique virtual experience.
				</p>
				<p class="text">
					Join the celebration by clicking “Enter Gallery” to witness the triumph of soccer and artful expression.
				</p>
			</div>
		</ParagraphContainer>

		<ParagraphContainer hasBackground={true} isBlack={true} progress={progress === 100}>
			<Button
				isDisabled={progress !== 100}
				onClick={(e) => {
          e.preventDefault();
          onEnter(layoutContainer);
        }}
				text={progress !== 100 ? progress + "%" : "Enter gallery"}
				type={"button"}
				style="margin: auto"
			/>

		</ParagraphContainer>
	</div>
</section>

<style type="text/scss">
  @import "../../styles/styles.scss";

  .container {
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 100%;
    z-index: 2;
    opacity: 1;
    overflow: hidden;
    touch-action: pan-y;
    user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;

    @keyframes lineairAnimation {
      0% {
        top: 0.125px;
      }

      50% {
        top: 4px;
      }

      100% {
        top: 0.125px;
      }
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
  }

  .logo {
    display: inline-block;
    margin-bottom: 1rem;
  }

  .w-full {
    width: 100%;

    * {
      text-align: left !important;
      max-width: 100% !important;
    }
  }

  .text {
    width: 100%;
    max-width: 650px;
    font-size: 22.125px;
    line-height: 129.49%;
    font-family: $font-title-regular;
    letter-spacing: -0.025em;
    color: $color-white;
    text-align: center;

    &.header-text {
      font-size: 2rem;
      font-weight: 700;
      position: relative;
      display: inline;

      @media screen and (min-width: 1028px) {
      	font-size: 2rem;
				background-color: #000;
				padding: 0 1.25rem 0 0;
      }

			@media screen and (min-width: 1028px) {
        span {
          content: "";
          position: absolute;
          width: 30px;
          height: 100%;
          background-color: #f7de8c;
          top: 0;
          transform: skew(-25deg, 0);

          @media screen and (min-width: 1028px) {
            width: 20px;
          }

          &:first-child {
            right: -50px;

            @media screen and (min-width: 1028px) {
              right: -60px;
            }
          }

          &:nth-child(2) {
            right: -70px;

            @media screen and (min-width: 1028px) {
              right: -90px;
            }
          }
        }
      }

			@media screen and (min-width: 1028px) {
        &:before {
          content: "";
          position: absolute;
          left: -80px;
          width: 80px;
          height: 100%;
          background-color: #000;
          top: 0;
        }

        &:after {
          content: "";
          position: absolute;
          right: -30px;
          width: 50px;
          height: 100%;
          background-color: #000;
          top: 0;
          transform: skew(-25deg, 0);
        }
      }
    }
  }

  .landing-content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: $font-title-italic;

    p {
      font-size: 1.5rem;
    }
  }

  h1.text {
    font-family: $font-title-italic;
    z-index: 0;
  }

  .text.styled-text {
    font-family: $font-title-regular;
    font-size: 3.5rem;
    margin: 0;
    width: auto;
  }

  .text.styled-text.landing:nth-of-type(1) {
    position: absolute;
    left: 0%;
    top: 80px;
  }

  .text-path {
    position: absolute;
    left: 0;
    bottom: 10%;
    width: 100vw;
    height: 50%;
    transform: translate(0, 50%);
    opacity: 0.245;
  }

  textPath {
    font-family: $font-title-regular;
    font-size: 4rem;
    text-transform: uppercase;
    fill: #8b6039;
  }

  .text.styled-text.landing:nth-of-type(2) {
    position: absolute;
    right: 2%;
    bottom: 0;
  }

  .outro {
    z-index: 1;
    align-self: flex-end;
  }

  .footer {
    align-self: flex-end;
    margin-top: 20px;
    text-align: center;
    max-width: 600px;

    .copyright {
      margin: 0;
      font-family: $font-title-regular;
      font-weight: 300;
    }
  }

  @media screen and (min-width: 1028px) {
    .wrapper {
      flex-direction: row;
    }

    .text.styled-text.landing:nth-of-type(1) {
      left: -7.5%;
      top: 0px;
    }

    .text.styled-text.landing:nth-of-type(2) {
      right: 10%;
    }
    .text {
      font-size: 25px;
    }

    .text-path {
      bottom: 15%;
    }

    textPath {
      font-size: 2rem;
    }

    .text.styled-text {
      font-size: 4.5rem;
      margin-top: 25px;
    }
  }

  @media screen and (min-width: 1450px) {
    .text {
      font-size: 28px;
    }

    .text.styled-text {
      font-size: 7.5rem;
    }
  }
</style>
